import { reservationsApi } from "api/services/reservations";
import { PreviouslyOrderedItem } from "custom-types/Cart";
import logError from "utils/logError";

export const getItemsForUser = async (
  domainCountryCode: string,
  dispensaryId?: number
) => {
  const headers: Record<string, string> = {
    "X-Leafly-Id": "web-web",
  };

  try {
    const { data } = await reservationsApi({ domainCountryCode }).get<{
      cartItems: PreviouslyOrderedItem[] | [];
      totalCount: number;
      totalPages: number;
      nextPage: number | null;
      prevPage: number | null;
    }>(`/cart_items${dispensaryId ? `?dispensary_id=${dispensaryId}` : ``}`, {
      headers,
    });

    return data;
  } catch (e) {
    logError("Error in getItemsForUser resApiClient getUserItems");

    return {
      cartItems: [],
      totalCount: 0,
      totalPages: 0,
    };
  }
};
